import { Grid, Typography } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import { LoadingWidget } from '../../../../../widgets';
import SelectFieldBloquesPedagogicosComponent from '../../../bloques_pedagogicos/components/SelectFieldBloquesPedagogicos';
import { oneDocentesService } from '../../../docentes/DocentesService';
import SelectFieldDocentesComponent from '../../../docentes/components/SelectFieldDocentes';
import { allEstudiantesNotasEvaluativasAction } from '../../../estudiantes/EstudiantesAction';
import SelectFieldMateriasComponent from '../../../materias/components/SelectFieldMaterias';
import { allPlanEvaluacionAction } from '../../../plan_evaluacion/plan_evaluacion/PlanEvaluacionAction';
import SelectFieldSeccionesComponent from '../../../secciones/components/SelectFieldSecciones';
import {
  ALL_NOTAS_EVALUATIVAS,
  PARAMS_NOTAS_EVALUATIVAS,
} from '../NotasEvaluativasReducer';

const FiltrosNotasEvaluativasComponent = ({ setDocenteSelect = () => {} }) => {
  const dispatch = Redux.useDispatch();

  const loginStore = Redux.useSelector((state) => state.login);
  const notasEvaluativasStore = Redux.useSelector(
    (state) => state.notasEvaluativas,
  );
  const [materias, setMaterias] = React.useState([]);
  const [secciones, setSecciones] = React.useState([]);

  const [loadingGetDocente, setLoadingGetDocente] = React.useState(false);

  React.useEffect(() => {
    async function fecthData() {
      if (
        !loginStore.isAdminTeacher &&
        notasEvaluativasStore.params.idDocente
      ) {
        setLoadingGetDocente(true);
        const res = await oneDocentesService(
          notasEvaluativasStore.params.idDocente,
        );
        setDocenteSelect(res.data.data);
        setLoadingGetDocente(false);

        res.data.data.materias.forEach((el) => {
          setMaterias((prev) => [...prev, el.materia]);
        });
        res.data.data.secciones.forEach((el) => {
          setSecciones((prev) => [...prev, el.seccion]);
        });
      }
    }

    fecthData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notasEvaluativasStore.params.idDocente]);

  const getData = async (payload) => {
    dispatch({ type: PARAMS_NOTAS_EVALUATIVAS, payload });

    if (
      !payload.idBloquePedagogico ||
      !payload.idDocente ||
      !payload.idSeccion
    ) {
      return;
    }

    if (!payload) {
      dispatch({
        type: ALL_NOTAS_EVALUATIVAS,
        payload: { data: [] },
      });
    }

    const resPlan = await allPlanEvaluacionAction(dispatch, {
      idEntidad: payload.idEntidad,
      idBloquePedagogico: payload.idBloquePedagogico,
      idPeriodoAcademico: payload.idPeriodoAcademico,
      idDocente: payload.idDocente,
      idMateria: payload.idMateria,
      idSeccion: payload.idSeccion,
    });

    if (payload.idDocente && payload.idMateria && payload.idSeccion) {
      await allEstudiantesNotasEvaluativasAction(dispatch, payload);
    }
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12}>
        <Typography variant="h6" color="initial">
          FILTROS
        </Typography>
      </Grid>

      <Grid item xs={12} md={12}>
        <SelectFieldBloquesPedagogicosComponent
          value={notasEvaluativasStore.params.idBloquePedagogico}
          isEmpty={false}
          isAll={false}
          onChange={(idBloquePedagogico) => {
            getData({
              ...notasEvaluativasStore.params,
              idBloquePedagogico,
            });
          }}
        />
      </Grid>

      {(loginStore.isAdmin || loginStore.isRoot) && (
        <Grid item xs={12} md={12}>
          {loadingGetDocente && (
            <LoadingWidget pb={1} isLoading={loadingGetDocente} />
          )}
          <SelectFieldDocentesComponent
            id="filtro-docentes"
            value={notasEvaluativasStore.params.idDocente || ''}
            isAll={false}
            onChange={(idDocente) => {
              getData({
                ...notasEvaluativasStore.params,
                idDocente,
                idMateria: null,
                idSeccion: null,
              });
            }}
          />
        </Grid>
      )}

      <Grid item md={12}>
        <SelectFieldMateriasComponent
          isAll={false}
          value={notasEvaluativasStore.params.idMateria || ''}
          data={loginStore.isAdminTeacher ? null : materias}
          onChange={(idMateria) => {
            getData({
              ...notasEvaluativasStore.params,
              idMateria,
            });
          }}
        />
      </Grid>

      <Grid item xs={12} md={12}>
        <SelectFieldSeccionesComponent
          id="filtroSecciones"
          value={notasEvaluativasStore.params.idSeccion || ''}
          data={loginStore.isAdminTeacher ? null : secciones}
          isAll={false}
          onChange={(idSeccion) => {
            getData({
              ...notasEvaluativasStore.params,
              idSeccion,
            });
          }}
        />
      </Grid>
    </Grid>
  );
};

export default FiltrosNotasEvaluativasComponent;
